<template>
  <div>
    <b-modal
      id="modal-change-case-process"
      ref="modal-change-case-process"
      centered
      :title="$t('DEBTIA_CHANGE_CASE_PROCESS')"
      :ok-title="$t('DEBTIA_CHANGE')"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      size="md"
      @ok="submitHandler"
      @close="resetProcessChangeModal"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          v-if="errorMsg"
          variant="warning"
          show
        >
          <div class="alert-body">
            <span>{{ errorMsg }}</span>
          </div>
        </b-alert>
        <b-form
          ref="form"
          class="repeater-form"
        >

          <!-- Row Loop -->
          <b-row ref="row">

            <!-- Cost -->
            <b-col
              md="12"
            >
              <b-form-group
                :label="$t('DEBTIA_PROCESS')"
                label-for="case-process"
              >
                <v-select
                  v-model="processID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="processes"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="case-process"
                />
              </b-form-group>
            </b-col>
            <!-- danger -->
            <b-alert
              variant="danger"
              show
            >
              <div class="alert-body">
                <span>{{ $t('DEBTIA_CHANGE_CASE_PROCESS_CONFIRMATION') }}</span>
              </div>
            </b-alert>
            <b-col
              md="12"
            >
              <b-form-checkbox
                v-model="processChangeCheck"
                class="custom-control-primary"
              >
                {{ $t('DEBTIA_CONFIRM_CHANGE_PROCESS') }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol,
  BFormGroup,
  BForm,
  BAlert,
  BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@axios'
import { EventBus } from '@/event-bus'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'

export default {
  components: {
    vSelect,
    BOverlay,
    BAlert,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    caseId: {
      type: [Number, String],
      required: true,
    },
    currentProcessId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      required,
      errorMsg: '',
      processes: [],
      otherFilesIndex: 1,
      processID: 0,
      processChangeCheck: false,
    }
  },
  watch: {
    currentProcessId: {
      handler() {
        this.processID = this.currentProcessId
      },
    },
  },
  created() {
    this.getProcesses()
    // this.processID = this.currentProcessId
  },
  methods: {
    async getProcesses() {
      const url = '/process/get-processes-dropdown'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.processes = response.data.data.processes
        }
      })
    },
    submitHandler(evt) {
      evt.preventDefault()
      if (this.processChangeCheck) {
        this.loader = true
        axios.post('/process/case/add', {
          process_id: this.processID,
          case_id: this.caseId,
        }).then(response => {
          if (response.status === 200) {
            this.loader = false
            this.processChangeCheck = false
            this.$refs['modal-change-case-process'].hide()
            EventBus.$emit('refreshModules')
            EventBus.$emit('refreshLogs')
            EventBus.$emit('refreshStatmentWidget')
            EventBus.$emit('refreshBetalingInvoices')
            EventBus.$emit('refreshStateData')
            EventBus.$emit('refreshInstallmentPlan')
            EventBus.$emit('refreshSecondaryProcesses')
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Success',
                icon: 'CoffeeIcon',
                variant: 'primary',
                text: i18n.t('DEBTIA_PROCESS_ASSIGNED_MESSAGE'),
              },
            })
          }
        }).catch(error => {
          this.loader = false
          this.errorMsg = error.response.data.message
        })
      } else {
        this.errorMsg = i18n.t('DEBTIA_TICK_CHECKBOX')
      }
    },
    resetProcessChangeModal() {
      this.processChangeCheck = false
      this.processID = this.currentProcessId
      this.errorMsg = ''
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
